// extracted by mini-css-extract-plugin
export default {"quantity_container":"NI","hiddenflavorstring":"OI","loadingLine":"PI","productimgwrap":"QI","productimg":"RI","circlepic":"SI","productinfo":"TI","grey_x":"UI","cartrow":"VI","bold":"WI","title":"XI","blue":"YI","strike":"ZI","flexgap":"aJ","flavorstring":"bJ","nodecorate":"cJ","flavorstring_link":"eJ","rdstring":"fJ","removeditemblock":"gJ","removed_heading":"hJ","removed_text":"iJ","addback":"jJ"};
    if(module.hot) {
      // 1713996748168
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  